import { get } from 'lodash';
import { DIBS_ENABLE_ONLINE_PREVIEW, RX_FORMS_ENABLE_RETAINER_CASES } from '../constants/settings';

export const getGlobalSettings = state => state.settings.global || {};

export const isOnlineDibsPreviewEnabled = state =>
  Boolean(get(getGlobalSettings(state), DIBS_ENABLE_ONLINE_PREVIEW, false));

export const isRetainerCaseCreationEnabled = state =>
  Boolean(get(getGlobalSettings(state), RX_FORMS_ENABLE_RETAINER_CASES, true));
